import { People } from '@mui/icons-material'
import AddActionIcon from 'icons/AddActionIcon'
import CategoriesIcon from 'icons/iam/CategoriesIcon'

import * as Yup from 'yup'

export const toolbarActions = ({ canCreate, navigate, openModal }) => {
  const toolbar = [{
    label: 'Unlisted Jobs',
    icon: <People />,
    onClick: () => navigate('/iam/jobManagement?undefinedJobs=true')
  }]
  const createButton = {
    label: 'Add new',
    icon: <AddActionIcon />,
    onClick: () => openModal()
  }

  const goToJobsButton = {
    icon: <CategoriesIcon width={18} strokeColor={'#0970E6'} />,
    label: 'Jobs',
    onClick: () => navigate('/iam/jobManagement')
  }
  toolbar.push(goToJobsButton)
  if (canCreate) {
    toolbar.push(createButton)
  }
  return toolbar
}

export const columns = [
  { field: 'code', title: 'ISIM Code', align: 'left' },
  { field: 'name', title: 'Job Category', align: 'left' },
  { field: 'description', title: 'Description', align: 'left' },
  { field: 'active', title: 'Status', align: 'left', render: rowData => rowData.active ? 'Active' : 'Inactive' }
]

export const jobCategoryValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  code: Yup.string().required('Code is required'),
  description: Yup.string().required('Description is required')
})
